// Поддерживается вручную в синхроне с backend `WalletTransactionTypeIdEnum`
// (libs/types/src/balance/wallet/enums/wallet-transaction-type-id.enum.ts).
// При добавлении нового id на бэке — добавить и сюда.
export const transactionTypeIds = [
  { name: "Deposit items", id: 1, selected: false },
  { name: "Double game bet", id: 2, selected: false },
  { name: "Shop purchase", id: 3, selected: false },
  { name: "Double game win", id: 4, selected: false },
  { name: "Referral", id: 5, selected: false },
  { name: "Classic or fast played", id: 6, selected: false },
  { name: "Shop revoke", id: 7, selected: false },
  { name: "Warwick reserve", id: 8, selected: false },
  { name: "Warwick release", id: 9, selected: false },
  { name: "Warwick winning", id: 10, selected: false },
  { name: "Payment", id: 11, selected: false },
  { name: "Duel game bet", id: 12, selected: false },
  { name: "Duel game win", id: 13, selected: false },
  { name: "Duel game return", id: 14, selected: false },
  { name: "Balance payment", id: 15, selected: false },
  { name: "Free coins", id: 16, selected: false },
  { name: "Referral welcome bonus", id: 17, selected: false },
  { name: "Slots game bet", id: 18, selected: false },
  { name: "Slots game winning", id: 19, selected: false },
  { name: "Crash game bet", id: 20, selected: false },
  { name: "Crash game win", id: 21, selected: false },
  { name: "Manual refund", id: 22, selected: false },
  { name: "Trade refund", id: 23, selected: false },
  { name: "Promocode", id: 24, selected: false },
  { name: "King bet", id: 25, selected: false },
  { name: "King win", id: 26, selected: false },
  { name: "King bonus", id: 27, selected: false },
  { name: "Upgrader play", id: 28, selected: false },
  { name: "Upgrader sell", id: 29, selected: false },
  { name: "Case play", id: 30, selected: false },
  { name: "Case sell", id: 31, selected: false },
  { name: "Daily gifts", id: 32, selected: false },
  { name: "Global pot", id: 33, selected: false },
  { name: "Wheel refill", id: 34, selected: false },
  { name: "Skin sell", id: 35, selected: false },
  { name: "x50 bet", id: 36, selected: false },
  { name: "x50 win", id: 37, selected: false },
  { name: "Virtual bet", id: 38, selected: false },
  { name: "Payout", id: 39, selected: false },
  { name: "Payout revoke", id: 40, selected: false },
  { name: "Tower game bet", id: 41, selected: false },
  { name: "Tower game win", id: 42, selected: false },
  { name: "Wheel spin", id: 43, selected: false },
  { name: "Mini jackpot win", id: 44, selected: false },
  { name: "Double game triple win", id: 45, selected: false },
  { name: "Hilo bet", id: 46, selected: false },
  { name: "Hilo win", id: 47, selected: false },
  { name: "Jackpot reward", id: 48, selected: false },
  { name: "Boost reward", id: 49, selected: false },
  { name: "Money move from dapubg", id: 50, selected: false },
  { name: "XP reward", id: 51, selected: false },
  { name: "Cashback reward", id: 52, selected: false },
  { name: "Baccarat play", id: 53, selected: false },
  { name: "Baccarat win", id: 54, selected: false },
  { name: "Cross return", id: 55, selected: false },
  { name: "Poggi slots bet", id: 56, selected: false },
  { name: "Poggi slots win", id: 57, selected: false },
  { name: "Wheel free bonus", id: 58, selected: false },
  { name: "Cases free bonus", id: 59, selected: false },
  { name: "HTTP API take", id: 60, selected: false },
  { name: "Leaders race reward", id: 61, selected: false },
  { name: "Taking raffle item", id: 62, selected: false },
  { name: "Unused money", id: 63, selected: false },
  { name: "Inventory sell", id: 64, selected: false },
  { name: "Inventory buy", id: 65, selected: false },
  { name: "P2P payout", id: 67, selected: false },
  { name: "P2P refund", id: 68, selected: false },
  { name: "P2P refill", id: 69, selected: false },
  { name: "P2P bot refill", id: 70, selected: false },
  { name: "Offerwall payment", id: 71, selected: false },
  { name: "Reset balance", id: 72, selected: false },
  { name: "Case battle bet", id: 80, selected: false },
  { name: "Case battle win", id: 81, selected: false },
  { name: "Case battle revenge accept", id: 82, selected: false },
  { name: "Case battle revenge refund", id: 83, selected: false },
  { name: "Case refund", id: 90, selected: false },
  { name: "Inventory withdraw refund", id: 91, selected: false },
  { name: "Rain bet", id: 100, selected: false },
  { name: "Rain refill", id: 101, selected: false },
  { name: "Rain reward", id: 102, selected: false },
  { name: "Raffle refill", id: 103, selected: false },
  { name: "Raffle reward", id: 104, selected: false },
  { name: "Raffle reward create", id: 105, selected: false },
  { name: "Raffle reward delete", id: 106, selected: false },
  { name: "Quest pay", id: 500, selected: false },
  { name: "Quest pay refund", id: 501, selected: false },
  { name: "Quest reward", id: 503, selected: false },
  { name: "Lucky bonus", id: 504, selected: false },
  { name: "Bonus from bet", id: 505, selected: false },
  { name: "Get bonus", id: 506, selected: false },
  { name: "Quest calendar reward", id: 507, selected: false },
  { name: "Get free wallet", id: 508, selected: false },
  { name: "Exchange wallet", id: 509, selected: false },
  { name: "Deposit items compensation hold", id: 510, selected: false },
  { name: "Solitaire entry cost", id: 600, selected: false },
  { name: "Solitaire prize", id: 601, selected: false },
  { name: "Solitaire refund", id: 602, selected: false },
];

export const sourceType = [
  {
    title: "All",
    value: "all",
    selected: false
  },
  {
    title: "Balance",
    value: "balance",
    selected: false
  },
  {
    title: "Inventory",
    value: "inventory",
    selected: false
  }
]
